import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getUserDecision } from "../decision";
import { isCrawler, promiseTimeout } from "../utils";

/**
 * Dynamically allow to get a predecision with a extra request to an external API.
 * If your server does not respond within a given timeout or with an error, it automatically
 * continues with the predecisions. Otherwise, the predecision of the response is used.
 */
var preDecisionGatewayDynamicRequest = function preDecisionGatewayDynamicRequest(request) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
  var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var decisionCookieName, revisionHash, decision, revision, _yield$promiseTimeout, predecision;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              decisionCookieName = _ref.decisionCookieName, revisionHash = _ref.revisionHash;

              if (!(isCrawler() || !active)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              // Check if revision has changed, and probably access our dynamic predecision again
              decision = getUserDecision(decisionCookieName);

              if (!decision) {
                _context.next = 8;
                break;
              }

              revision = decision.revision;

              if (!(revisionHash === revision)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", "consent");

            case 8:
              _context.prev = 8;
              _context.next = 11;
              return promiseTimeout(request(), timeout);

            case 11:
              _yield$promiseTimeout = _context.sent;
              predecision = _yield$promiseTimeout.predecision;
              return _context.abrupt("return", predecision);

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](8);
              return _context.abrupt("return", false);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 16]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

export { preDecisionGatewayDynamicRequest };